import { CrashDescription, IssueTag } from '../../../common/src/model.ts';
import * as server_api from '../../../common/src/server_api.ts';
import { localStorageGet, LocalStorageKey } from '../data/client_local_storage.ts';

export function reportCrash(event: ErrorEvent) {
  // avoid reporting twice for same error
  // "reported" is a made up property - this works because the same error object is used the second time around
  if (event.error.reported) {
    return false;
  }
  event.error.reported = true;
  const details =
    event.target instanceof HTMLElement
      ? `Resource failed: ${event.target.tagName}, ${event.target.localName}, ${event.target.id}, ${event.target.className}`
      : '';
  const crashDescription = `${event.message}\n${event.filename}:${event.lineno}:${event.colno}\n${details}\n${event.error.stack}`;
  reportCrashDescription(crashDescription);
  return false;
}

// files a crash issue (and so a crash email) for a problem the app caught rather than an uncaught error
export function reportCrashDescription(crashDescription: string) {
  console.error(`Reporting error ${crashDescription}`);
  const bundleHash = localStorageGet(LocalStorageKey.BundleHash);
  const description: CrashDescription = {
    tag: IssueTag.Crash,
    description: crashDescription,
    bundleHash,
  };
  void server_api.addIssue({
    timestamp: Date.now(),
    description,
  });
}
